import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VLayout,{attrs:{"column":""}},[_c('contact-sync-configuration',{attrs:{"email":_vm.email}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }